import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";

export const createProjectRequest = createAsyncThunk(
  'managerProjectRequested/create',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/managerProjectRequested/create", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Unknown error occurred" });
    }
  }
);

export const getAllProjectRequests = createAsyncThunk(
  'managerProjectRequested/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/managerProjectRequested");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data.message);
    }
  }
);

export const getRequestsByAssignedTo = createAsyncThunk(
  'managerProjectRequested/getByAssignedTo',
  async (assignedTo, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/managerProjectRequested/assignedto/${assignedTo}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data.message);
    }
  }
);

export const updateProjectRequest = createAsyncThunk(
  'managerProjectRequested/update',
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/managerProjectRequested/${id}`, updatedData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data.message);
    }
  }
);

export const deleteProjectRequest = createAsyncThunk(
  'managerProjectRequested/delete',
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/managerProjectRequested/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response.data.message);
    }
  }
);

const managerProjectRequestedSlice = createSlice({
  name: 'managerProjectRequested',
  initialState: {
    projects: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(createProjectRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createProjectRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.projects.unshift(action.payload);
      })
      .addCase(createProjectRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAllProjectRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllProjectRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = action.payload;
      })
      .addCase(getAllProjectRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getRequestsByAssignedTo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRequestsByAssignedTo.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = action.payload;
      })
      .addCase(getRequestsByAssignedTo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateProjectRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProjectRequest.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.projects.findIndex(p => p._id === action.payload._id);
        if (index !== -1) {
          state.projects[index] = action.payload;
        }
      })
      .addCase(updateProjectRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteProjectRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProjectRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = state.projects.filter(p => p._id !== action.payload);
      })
      .addCase(deleteProjectRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default managerProjectRequestedSlice.reducer;
